import { computed, inject, provide, toValue } from 'vue'

const readonlyFormKey = Symbol('readonlyForm')

export const provideReadonlyForm = (readonly) => {
  const isReadonly = computed(() => !!toValue(readonly))
  provide(readonlyFormKey, isReadonly)
  return isReadonly
}

export const useReadonlyField = (readonly) => {
  const formReadonly = inject(readonlyFormKey, null)
  return computed(() => !!toValue(readonly) || !!formReadonly?.value)
}
